export const boxPlanningKeys = {
  all: ["boxPlanning"] as const,
  slots: (filters?: { startDate: Date | undefined; endDate: Date | undefined; programId: string | undefined }) =>
    filters ? ([...boxPlanningKeys.all, "slots", filters] as const) : ([...boxPlanningKeys.all, "slots"] as const),
}
